import { createStore } from 'zustand-x';

export const bottomMenuStore = createStore('bottomMenu')(
  {
    isBottomMenuOpen: false,
    isDialogOpen: false,
  },
  { devtools: { enabled: true } }
).extendActions((set) => ({
  openBottomMenu: () => {
    set.isBottomMenuOpen(true);
  },
  closeBottomMenu: () => {
    set.isBottomMenuOpen(false);
  },
  openDialog: () => {
    set.isDialogOpen(true);
  },
  closeDialog: () => {
    set.isDialogOpen(false);
  },
}));
